import axios from 'axios';

const baseUrl = process.env.REACT_APP_API_URL;

export const getActiveNews = async (pageNum = 1, pageSize = 6, searchTerm = "", sortBy = "") => {
    try {
        const response = await axios.post(`${baseUrl}/News/GetActiveNews`, {
            pageNum: pageNum.toString(),
            pageSize: pageSize.toString(),
            searchTerm,
            sortBy
        });
        
        return response.data;
    } catch (error) {
        console.error('Error fetching news:', error);
        throw error;
    }
};

export const getNewsByGuid = async (guid) => {
    try {
        console.log('Fetching news details for GUID:', guid);
        const response = await axios.post(`${baseUrl}/News/GetNewsByGuid`, {
            guid: guid
        });
        
        console.log('News details response:', response.data);
        return response.data;
    } catch (error) {
        console.error('Error fetching news details:', error);
        throw error;
    }
};
